<section class="flex flex-col w-full h-full gap-8 sm:gap-12 lg:gap-20">
  <app-stepper-container p-stepper-container></app-stepper-container>
  <!-- Your Order Benefits Section -->
  <div class="mx-auto max-w-[1470px] w-full px-4 sm:px-6 lg:px-8 mb-8 sm:mb-12">
    <div class="px-4 sm:px-6 lg:px-8">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div class="p-5 sm:p-6 lg:p-8 space-y-6 sm:space-y-8">
        <!-- Payment Methods Section -->
        <div class="bg-gray-50/70 rounded-xl p-5 sm:p-6 border border-gray-100">
          <div class="text-center mb-3 sm:mb-4">
            <h3 class="text-sm sm:text-base font-semibold text-gray-800">{{ 'Bezpieczne metody płatności' | translate }}</h3>
            <p class="text-xs sm:text-sm text-gray-500 mt-0.5">{{ 'Wybierz jedną z dostępnych, sprawdzonych metod płatności' | translate }}</p>
          </div>
          <!-- Payment Banner Image (Properly sized and sharp, no cropping) -->
          <div class="max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto p-4 sm:p-5 bg-white rounded-xl border border-gray-200/80 shadow-sm flex items-center justify-center">
            <img
              src="/images/paynow-baaner.png"
              [alt]="'Metody płatności PayNow' | translate"
              class="w-full h-auto max-h-28 sm:max-h-36 object-contain"
              loading="lazy"
            />
          </div>
        </div>

        <!-- Key Benefits Grid -->
        <div class="mx-auto grid w-full max-w-5xl grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6">
          <!-- Return Policy -->
          <div
            class="bg-orange-50/50 rounded-xl p-4 sm:p-5 border border-orange-200/80">
            <div class="flex items-start gap-3 sm:gap-4">
              <div class="w-9 h-9 rounded-lg bg-orange-500 flex items-center justify-center shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor" class="size-5 text-white">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                </svg>
              </div>
              <div class="flex-1 min-w-0">
                <h4 class="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{{ 'Zwroty i wymiana' | translate }}</h4>
                <p class="text-xs text-gray-600 mb-2">
                  {{ 'Obowiązują warunki, terminy i wyłączenia dotyczące wybranych produktów. Przed złożeniem zamówienia zapoznaj się z zasadami.' | translate }}
                </p>
              </div>
            </div>
          </div>

          <!-- Quality Guarantee -->
          <div
            class="bg-orange-50/50 rounded-xl p-4 sm:p-5 border border-orange-200/80">
            <div class="flex items-start gap-3 sm:gap-4">
              <div class="w-9 h-9 rounded-lg bg-orange-500 flex items-center justify-center shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor" class="size-5 text-white">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9 12.75L11.25 15 15 9.75m-3.75-6.75h3.75a2.25 2.25 0 012.25 2.25v13.5a2.25 2.25 0 01-2.25 2.25H6.75a2.25 2.25 0 01-2.25-2.25V8.25a2.25 2.25 0 012.25-2.25h3.75z" />
                </svg>
              </div>
              <div class="flex-1 min-w-0">
                <h4 class="font-semibold text-gray-900 mb-1 text-sm sm:text-base">{{ 'Wsparcie dotyczące produktów' | translate }}</h4>
                <p class="text-xs text-gray-600 mb-2">
                  {{ 'Potrzebujesz pomocy w sprawie specyfikacji lub kompatybilności? Skontaktuj się z naszym zespołem.' | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</section>